import type { FinalizeGorgiasDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";

export interface GorgiasApiError {
	message?: string;
	code?: string;
	statusCode?: number;
}

export default function useFinalizeGorgiasIntegration({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: GorgiasApiError) => void;
} = {}) {
	return useApiMutation("post", "/gorgias/finalize", {
		notify: false,
		onSuccess,
		onError: (error: unknown) => {
			const apiError = error as GorgiasApiError;
			onError?.(apiError);
		},
		mapVariables: (data: FinalizeGorgiasDto) => ({
			body: data,
		}),
	});
}
